import { useTranslation } from "react-i18next";
import { RiskLevelBadge } from "./RiskLevelBadge";
import { scoreToLevel } from "./riskUtils";
import { sjaHazardScore } from "./sjaHazards";

export function SjaHazardRisk({ hazard }) {
  const { t } = useTranslation();
  const score = sjaHazardScore(hazard);
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm" aria-live="polite">
      {score > 0 && <span>{t("hse.sja.fields.score", { likelihood: hazard.likelihood, consequence: hazard.consequence, score })}</span>}
      <RiskLevelBadge level={scoreToLevel(score)} />
    </div>
  );
}

export function SjaHazardFields({ hazard, path, errors, onChange, onRemove, inputClass }) {
  const { t } = useTranslation();
  const errorFor = (field) => errors[`${path}.${field}`];
  const errorId = (field) => `${path}.${field}.error`;
  return (
    <fieldset className="mt-3 space-y-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
      <legend className="px-1 text-sm font-semibold">{t("hse.sja.fields.hazard")}</legend>
      <label className="block text-sm">
        {t("hse.risk.fields.description")}
        <textarea className={inputClass} rows={2} value={hazard.description}
          onChange={(event) => onChange("description", event.target.value)}
          aria-invalid={!!errorFor("description")} aria-describedby={errorFor("description") ? errorId("description") : undefined} />
        {errorFor("description") && <span id={errorId("description")} className="text-rose-700">{t(errorFor("description"))}</span>}
      </label>
      <div className="grid gap-3 sm:grid-cols-2">
        {["likelihood", "consequence"].map((field) => (
          <label key={field} className="block text-sm">
            {t(field === "likelihood" ? "hse.risk.fields.likelihood" : "hse.risk.fields.consequence_score")}
            <select className={inputClass} value={hazard[field]}
              onChange={(event) => onChange(field, event.target.value === "" ? "" : Number(event.target.value))}
              aria-invalid={!!errorFor(field)} aria-describedby={errorFor(field) ? errorId(field) : undefined}>
              <option value="">{t("hse.sja.fields.choose_score")}</option>
              {[1, 2, 3, 4, 5].map((value) => <option key={value} value={value}>{value} – {t(`hse.risk.scale.${field}.${value}`)}</option>)}
            </select>
            {errorFor(field) && <span id={errorId(field)} className="text-rose-700">{t(errorFor(field))}</span>}
          </label>
        ))}
      </div>
      <SjaHazardRisk hazard={hazard} />
      {["existing_measures", "additional_measures"].map((field) => (
        <label key={field} className="block text-sm">
          {t(`hse.sja.fields.${field}`)}
          <textarea rows={2} className={inputClass} value={hazard[field]} onChange={(event) => onChange(field, event.target.value)} />
        </label>
      ))}
      <button type="button" onClick={onRemove} className="text-sm font-semibold text-rose-700">{t("hse.sja.fields.remove_hazard")}</button>
    </fieldset>
  );
}
